<template>
  <section v-if="contextData">
    <div class="container-wrap py-9 tablet:py-12">
      <h2 class="text-solution-h2 mb-2 tablet:line-clamp-2">
        {{ contextData.title }}
      </h2>
      <p
        class="mb-6 text-sm text-gray-600 tablet:mb-8 tablet:line-clamp-3 tablet:text-base desktop:mb-6 desktop:w-2/3"
      >
        {{ contextData.description }}
      </p>

      <ul v-if="isMobile">
        <li
          v-for="item in contextItems"
          :key="hash(item)"
          class="mb-3 last:mb-0"
        >
          <SuiteDfsiCard :item-data="item" :url-connector="urlConnector" />
        </li>
      </ul>

      <CarouselProgressbar
        v-else
        :carousel-list="contextItems"
        :slides-per-view="slidesPerView"
      >
        <template #card="{ item }">
          <SuiteDfsiCard :item-data="item" :url-connector="urlConnector" />
        </template>
      </CarouselProgressbar>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description: string;
    thumbnail: string;
    areas: string[];
  }

  interface IDfsiData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IDfsi {
    component: 'dfsi';
    meta: {
      navigable?: string;
    };
    data: IDfsiData;
  }

  type IProps = ISuiteProps<IDfsi>;

  const props = defineProps<IProps>();

  const { isMobile, isDesktop } = useScreen();

  const contextData = computed((): IDfsiData => props.suiteData.data);

  const contextItems = computed((): IItem[] => contextData.value.items);

  const slidesPerView = computed((): number => {
    if (isDesktop.value) return 3;
    return 2;
  });

  export type { IDfsi, IDfsiData, IItem };
</script>
